<div class="background"></div>
<div class="container" *ngIf="(currentUser$ | async) === null">
  <div class="login-wrapper">
    <div class="login-card-container">
      <form (ngSubmit)="loginBtn()">
        <mat-card appearance="outlined" class="card">
          <mat-card-title class="card-header">{{loginHeader}}</mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
          <mat-card-content class="card-form">
            <div class="form-row">
              <i class="material-icons">email</i>
              <mat-form-field color="accent">
                <mat-label>Email address</mat-label>
                <input matInput type="email" name="username" [(ngModel)]="model.username" required />
              </mat-form-field>
            </div>
            <div class="form-row">
              <i class="material-icons">lock_outline</i>
              <mat-form-field color="accent">
                <mat-label>Password</mat-label>
                <input [type]="isPasswordVisible ? 'text' : 'password'" matInput name="password"
                  [(ngModel)]="model.password" (keyup)="handleKeyUp($event)" required />
                <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button">
                  <mat-icon>{{ isPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="form">
              <span style="color: red"><b>{{msg}}</b></span>
            </div>
            <div *ngIf="isLoaderResult"
              style="display:flex; justify-content:content; align-items:center; position:absolute; top:40%;left:35%">
              <mat-spinner color="warn"></mat-spinner>
            </div>
            <div class="form-row">
              <div style="float:right;text-align:right;margin-left: auto;margin-right: 0">
                <a mat-button style="color: hotpink;" (click)="forgotPassword()" target="_blank">Forgot Password</a>
              </div>
            </div>
          </mat-card-content>
          <mat-card-footer class="card-footer">
            <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
              (click)="loginBtn()">Login</button>
          </mat-card-footer>
        </mat-card>
      </form>
    </div>
  </div>
</div>
